import { ValueOf } from '@shared/utils/type-util';

export const FLOW_RX_STEP_ATTR = 'flow-rx-step';

export const FLOW_RX_STEPS = {
	PatientDetails: 'patient-details',
	ProcedureSelection: 'procedure-selection',
	RxForm: 'rx-form'
} as const;

export type FlowRxStep = ValueOf<typeof FLOW_RX_STEPS>;
